<div class="row">
  <div class="col-md-7 col-lg-7 col-xs-10 m-auto">
    <img src="../../assets/images/verify_with_agent01.jpg" style="width: 100%;">
  </div>
  <div class="col-12 text-center">
    <button class="btn btn-secondary m-2">
      <span class="fa fa-level-up-alt fa-rotate-270"></span>
      กลับ
    </button>
    <button class="btn btn-ok m-2">
      <span class="fa fa-check"></span>
      ตกลง
    </button>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/financial-institution/financial-institution.component.html